import { __assign } from "tslib";
import React from 'react';
import { SplitClient } from './SplitClient';
/**
 * High-Order Component for SplitClient.
 * The wrapped component receives all the props of the container,
 * along with the passed props from SplitClient (see ISplitClientChildProps).
 *
 * @param splitKey The customer identifier.
 * @param trafficType Traffic type associated with the customer identifier. If no provided here or at the config object, it will be required on the client.track() calls.
 */
export function withSplitClient(splitKey, trafficType, attributes) {
    return function withSplitClientHoc(WrappedComponent, updateOnSdkUpdate, updateOnSdkTimedout, updateOnSdkReady, updateOnSdkReadyFromCache) {
        if (updateOnSdkUpdate === void 0) { updateOnSdkUpdate = false; }
        if (updateOnSdkTimedout === void 0) { updateOnSdkTimedout = false; }
        if (updateOnSdkReady === void 0) { updateOnSdkReady = true; }
        if (updateOnSdkReadyFromCache === void 0) { updateOnSdkReadyFromCache = true; }
        return function wrapper(props) {
            return (React.createElement(SplitClient, { splitKey: splitKey, trafficType: trafficType, updateOnSdkUpdate: updateOnSdkUpdate, updateOnSdkTimedout: updateOnSdkTimedout, updateOnSdkReady: updateOnSdkReady, updateOnSdkReadyFromCache: updateOnSdkReadyFromCache, attributes: attributes }, function (splitProps) {
                return (React.createElement(WrappedComponent, __assign({}, props, splitProps)));
            }));
        };
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/withSplitClient.js
// module id = 3951
// module chunks = 25